import _axios from '@/utils/request'

// 全部的banner列表
export function postBannerList (params) {
    return _axios('post', `/ms-shulan-hospital/v1/banner/bannerList`, params)
}
// 删除banner
export function deleteBanner (bannerId) {
    return _axios('delete', `/ms-shulan-hospital/v1/banner/${bannerId}`)
}

// 下线banner
export function postDismountedBanner (bannerId) {
    return _axios('post', `/ms-shulan-hospital/v1/banner/dismountedBanner/${bannerId}`)
}

// 上线banner
export function postShelfBanner (bannerId) {
    return _axios('post', `/ms-shulan-hospital/v1/banner/shelfBanner/${bannerId}`)
}
// 上线视频集内的banner
export function postVideoSetShelfBanner (bannerId) {
    return _axios('post', `/ms-shulan-hospital/v1/banner/collect/shelfBanner/${bannerId}`)
}

// 添加banner 旧的：/ms-shulan-hospital/v1/banner
export function postAddBanner (params) {
    return _axios('post', `/ms-shulan-hospital/v1/banner/addBanner`, params)
}

// 更新banner 旧的：/ms-shulan-hospital/v1/banner
export function putBanner (params) {
    return _axios('put', `/ms-shulan-hospital/v1/banner/updateBanner`, params)
}

// 获取banner
export function getBanner (bannerId) {
    return _axios('get', `/ms-shulan-hospital/v1/banner/${bannerId}`)
}

// 上移banner
export function getBannerMoveUp (bannerId) {
    return _axios('get', `/ms-shulan-hospital/v1/banner/moveUp/${bannerId}`)
}

// 下移banner
export function getBannerMoveDown (bannerId) {
    return _axios('get', `/ms-shulan-hospital/v1/banner/moveDown/${bannerId}`)
}
